var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chat',{attrs:{"desfase":0,"momento":1,"finalizado":"","limitar-mensajes":false,"tipo":5,"user":_vm.id_pedido,"fecha-finalizado":_vm.detalle.fecha_finalizado_chat}})
}
var staticRenderFns = []

export { render, staticRenderFns }